import cl from 'clsx';
import { PlaceHolderImage } from '@/shared/assets';
import CopyIcon from '@synapex/frontend-shared/icons/copy-16.svg?react';
import { Button, type ButtonProps } from '@synapex/frontend-shared/ui/Button';
import { useToastStack } from '@/true-fsd/shared/ui/Toast';
import { useCopyToClipboard } from 'usehooks-ts';
import { useActiveUser, ActiveUser } from '@/true-fsd/data/advertiser-account';
import { useReferralsCount } from '@/true-fsd/data/referral';
import { addReferrer } from '@synapex/shared2/services/referral';

import classes from './ReferrerInfo.module.scss';
import { ReactNode } from 'react';

const BUTTON_CLASSES: ButtonProps['classes'] = {
  root: classes.button,
  content: classes.text,
  suffixIcon: classes.icon,
};

const useReferralLink = (user: ActiveUser) => {
  const toast = useToastStack();
  const [, copy] = useCopyToClipboard();

  const landingUrl = new URL(import.meta.env.VITE_LANDING_URL);
  addReferrer(landingUrl.searchParams, user);
  const referralHref = landingUrl.href;

  const onClick = () =>
    copy(referralHref).then(() => toast('Скопировано в буфер обмена'));

  return {
    href: referralHref,
    onClick,
  };
};

type InfoProps = {
  className?: string;
  title: string;
  children: ReactNode;
};
const Info = ({ className, title, children }: InfoProps) => {
  return (
    <div className={cl(classes.info, className)}>
      <div className={classes.title}>{title}</div>
      <div className={classes.children}>{children}</div>
    </div>
  );
};

export type ReferrerInfoProps = {
  className?: string;
};
export const ReferrerInfo = ({ className }: ReferrerInfoProps) => {
  const user = useActiveUser();
  const referralLink = useReferralLink(user);
  const referralsCount = useReferralsCount();

  return (
    <div className={cl(classes.root, className)}>
      <div className={classes.user}>
        <img
          src={user.photo_url ?? PlaceHolderImage}
          className={classes.photo}
        />
        <div className={classes.name}>{user.full_name}</div>
      </div>
      <div className={classes.left}>
        <Info title={'Ваш реферальный бонус:'}>20%</Info>
        <Info title={'Вы заработали за все время:'}>0 ₽</Info>
        <Info title={'Кол-во ваших рефералов:'}>{referralsCount}</Info>
        <p className={classes.description}>
          <span>
            Партнерская программа ООО “СИНАПЕКС” доступна после заключения
            договора. Данная партнерская программа может изменяться. Партнерские
            выплаты доступны в течении 1 года с момента регистрации клиента.
            Вывод осуществляется только на р/c юр.лица. Минимальный вывод
            составляет 10 000 ₽.
          </span>
          <br /> <span>Для вывода напишите в поддержку.</span>
        </p>
      </div>
      <div className={classes.right}>
        <div className={classes.title}>Ваша реферальная ссылка:</div>
        <Button
          SuffixIcon={CopyIcon}
          classes={BUTTON_CLASSES}
          onClick={referralLink.onClick}
        >
          {referralLink.href}
        </Button>
      </div>
    </div>
  );
};
